import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import {
  dashboardEmployee,
  dashboardEmployeeInYear,
} from "../../../helpers/helper";
import { listMonth, listYear } from "../../../helpers/common";

const { Option } = Select;

function DashboardEmployee() {
  const { t } = useTranslation();
  document.title = t("menuTotal");
  const date = new Date();
  const [dataEmployee, setDataEmployee] = useState([]);
  const [dataEmployeeInYear, setDataEmployeeInYear] = useState([]);
  const [valueMonth, setValueMonth] = useState(
    `${date.getMonth() + 1},${date.getFullYear()}`
  );
  const [year, setYear] = useState(new Date().getFullYear());
  const listDataMonth = listMonth(date, 6);
  const listDataYear = listYear(date);

  const handleChange = (value) => {
    setValueMonth(value);
  };

  const handleChangeYear = (value) => {
    setYear(value);
  };

  useEffect(() => {
    try {
      const dateTime = valueMonth.split(",");
      const fecthData = async () => {
        let time = {
          month: parseInt(dateTime[0]),
          year: parseInt(dateTime[1]),
        };
        let timeInYear = {
          year: year,
        };
        const dataRes = await dashboardEmployee(time);

        dataRes.map((item) => {
          if (item.type === "Nhân viên mới") {
            item.type = t("newUser");
          } else {
            item.type = t("bloclUser");
          }
        });
        setDataEmployee(dataRes);
        const dataResInYear = await dashboardEmployeeInYear(timeInYear);
        setDataEmployeeInYear(dataResInYear);
      };
      fecthData();
    } catch (error) {
      console.log(error);
    }
  }, [valueMonth, year]);

  const config = {
    data: dataEmployee,
    isGroup: true,
    xField: "date",
    yField: "value",
    seriesField: "type",
    dodgePadding: 2,
    intervalPadding: 20,
    label: {
      position: "middle",
      layout: [
        {
          type: "adjust-color",
        },
      ],
    },
  };

  const configEmployeeInYear = {
    data: dataEmployeeInYear,
    xField: "type",
    yField: "value",
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: {
        alias: t("month"),
      },
      value: {
        alias: t("newUser"),
      },
    },
  };

  return (
    <>
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: "35px", paddingBottom: "5px" }}>
              {t("dualChart")}
            </div>
            <div>{`${t("statisticalChartNewUser")} ${
              valueMonth.split(",")[0]
            }/${valueMonth.split(",")[1]}`}</div>
          </div>
          <div style={{ padding: "20px" }}>
            <Select
              showSearch
              options={listDataMonth}
              value={valueMonth}
              onChange={handleChange}
              style={{ width: "200px" }}
            >
              {listDataMonth.length > 0 &&
                listDataMonth.map((key, item) => {
                  return (
                    <Option key={key} value={item.valueOf}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          </div>
        </div>
        <Column {...config} style={{ padding: "20px" }} />
      </div>

      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: "35px", paddingBottom: "5px" }}>
              {t("columnChart")}
            </div>
            <div>{`${t("onSiteChartUser")} ${year}`}</div>
          </div>
          <div style={{ padding: "20px" }}>
            <Select
              showSearch
              options={listDataYear}
              value={t("year") + " " + year}
              onChange={handleChangeYear}
              style={{ width: "200px" }}
            >
              {listDataYear.length > 0 &&
                listDataYear.map((key, item) => {
                  return (
                    <Option key={key} value={item.valueOf}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          </div>
        </div>
        <Column {...configEmployeeInYear} style={{ padding: "20px" }} />
      </div>
    </>
  );
}

export default DashboardEmployee;
